<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-font-colors`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 40a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4a1 1 0 011-1h38zM26.006 4.001a1 1 0 01.932.636l12.12 30.999A1 1 0 0138.126 37h-2.413a1 1 0 01-.931-.636L30.729 26H17.442l-4.091 10.367a1 1 0 01-.93.633h-2.416a1 1 0 01-.93-1.367L21.307 4.634a1 1 0 01.93-.633h3.768zm-1.89 5.086L19.022 22h10.144L24.117 9.087z"/></svg>
</template>
<script>

export default {
  name: 'IconFontColors',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
